"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Europa = void 0;
var Colony_1 = require("./Colony");
var Resources_1 = require("../Resources");
var ColonyName_1 = require("./ColonyName");
var ColonyBenefit_1 = require("./ColonyBenefit");
var Europa = (function (_super) {
    __extends(Europa, _super);
    function Europa() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = ColonyName_1.ColonyName.EUROPA;
        _this.description = 'Production';
        _this.buildType = ColonyBenefit_1.ColonyBenefit.PLACE_OCEAN_TILE;
        _this.tradeType = ColonyBenefit_1.ColonyBenefit.GAIN_PRODUCTION;
        _this.tradeResource = [
            Resources_1.Resources.MEGACREDITS, Resources_1.Resources.MEGACREDITS,
            Resources_1.Resources.ENERGY, Resources_1.Resources.ENERGY,
            Resources_1.Resources.PLANTS, Resources_1.Resources.PLANTS, Resources_1.Resources.PLANTS,
        ];
        _this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES;
        _this.colonyBonusResource = Resources_1.Resources.MEGACREDITS;
        _this.shouldIncreaseTrack = Colony_1.ShouldIncreaseTrack.ASK;
        return _this;
    }
    return Europa;
}(Colony_1.Colony));
exports.Europa = Europa;
